<template>
    <div>
        <div class="xinz">
           <!-- <div class="right">
                <el-button type="warning" @click="addCustGroup"><i class="fa fa-plus" /> {{$t('m.t_newcustomergroup')}}</el-button>
            </div>-->
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getItemStorList" size="small">
                <el-form-item :label="$t('m.t_search')">
                    <!--<el-input placeholder="產品名稱"  v-model="serchItemName" clearable>
                    </el-input>-->
                    <el-select  v-model="serchItemName" default-first-option filterable  remote  clearable :remote-method="getItemOptions" placeholder="" style="width:150px" @change="itemOptionChange">
                        <el-option
                                v-for="item in itemOptions"
                                :key="item.id"
                                :label="item.itemName"
                                :value="item.itemName">
                            <span  style="float: left">{{ item.itemName }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getItemStorList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                </el-form-item>
                <el-form-item style="margin-left:370px;">
                <el-button type="warning" v-if="canAdd" @click="itemListAdd"><i class="fa fa-plus" /> 新增產品</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                      v-loading="tableloading"
                      @selection-change="handleSelectionChange"
                      :data="itemStorList"
                      :empty-text="$t('m.t_nodata')"
                      style="width: 800px"
                      stripe
                      border
                      class="dataListTable">
                <el-table-column
                        prop="itemName"
                        align="left"
                        label="產品名稱">
                </el-table-column>
                <el-table-column
                        prop="stockAvail"
                        align="left"
                        width="110"
                        label="總數量">
                </el-table-column>
                <el-table-column
                        prop="stockOnhold"
                        align="left"
                        width="110"
                        label="已用數量">
                </el-table-column>
                <el-table-column
                        prop="storCode"
                        label="可用數量"
                        width="110">
                    <template slot-scope="scope">
                        {{scope.row.stockAvail-scope.row.stockOnhold}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="itemEdit(scope.row)" v-if="canEdit"><i class="fa fa-edit"/>{{$t('m.b_edit')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary"  @click.native="showInfo(scope.row)" v-if="canDetails"><i class="fa fa-search"/>詳情</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="updateStatus(scope.row.id)" v-if="candHide"><i class="fa fa-edit"/>隱藏</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="updateLog(scope.row.id)" v-if="candLOG"><i class="fa fa-edit"/>修改日誌</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
       <!-- <div class="pagination" style="width: 800px">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="itemPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>-->
        <!-- 編輯页面-->
        <el-dialog :title="dialogCodeName" :visible.sync="dialogCodeVisible" width="450px" :close-on-click-modal=false>
            <el-form  :model="itemForm" :rules="itemRules" ref="itemForm" label-width="160px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.b_prodcode')+'：'" prop="itemName">
                            <span v-if="this.itemForm.id!=''">{{itemForm.itemName}}</span>
                            <span v-else> <el-input v-model="itemForm.itemName" placeholder="" @change="validateItemName(itemForm.itemName)" auto-complete="off" style="width:200px" ></el-input></span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0" v-if="this.itemForm.id!=''">
                    <el-col :span="24">
                        <el-form-item label="貨存數量：" prop="oldQty">
                            {{itemForm.oldQty}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item label="調整數量：" prop="qty">
                            <el-input v-model="itemForm.qty" placeholder="" @change="calculateQty(itemForm.qty)" auto-complete="off" style="width:200px" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item label="調整后數量：" prop="adjQty">
                            <el-input v-model="itemForm.adjQty" placeholder="" @change="calculateAdjQty(itemForm.adjQty)" auto-complete="off" style="width:200px" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0" v-if="this.itemForm.id!=''">
                    <el-col :span="24">
                        <el-form-item label="原因：" prop="remark">
                            <el-input
                                    type="textarea"
                                    :autosize="{minRows: 4,maxRows: 10}"
                                    placeholder=""
                                    v-model="itemForm.remark" style="width:200px">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCodeVisible = false">{{$t('m.b_cancel')}}</el-button>
                <el-button type="primary" @click="itemListSave" :loading="addEidtloading">{{$t('m.b_save')}}</el-button>
            </div>
        </el-dialog>

        <!--日志列表页面-->
        <el-dialog :title="diaItemsName" :visible.sync="dialogItemVisible" width="60%">
            <div>
                <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                          v-loading="tableloading"
                          @selection-change="handleSelectionChange"
                          :data="itemLogList"
                          stripe
                          border
                          style="width: 100%">
                    <el-table-column
                            prop="itemName"
                            align="left"
                            width="100"
                            label="產品名稱">
                    </el-table-column>
                    <el-table-column
                            prop="stockAvail"
                            align="right"
                            width="100"
                            label="初始數量">
                    </el-table-column>
                    <el-table-column
                            prop="qty"
                            align="right"
                            width="100"
                            label="數量">
                    </el-table-column>
                    <el-table-column
                            prop="stockAvail"
                            align="right"
                            width="100"
                            label="修改後數量">
                        <template slot-scope="scope">
                                {{scope.row.stockAvail+scope.row.qty}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            align="left"
                            label="原因">
                    </el-table-column>
                    <el-table-column
                            prop="createBy"
                            align="left"
                            width="90"
                            label="創建人">
                    </el-table-column>
                    <el-table-column
                            prop="createDate"
                            align="left"
                            width="160"
                            label="創建時間">
                        <template slot-scope="scope">
                            <template v-if="scope.row.createDate!=0">
                                {{scope.row.createDate*1000 | date('%Y-%m-%d %H:%M:%s') }}
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="height: 50px">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogItemVisible = false">{{$t('m.b_cancel')}}</el-button>
            </div>
        </el-dialog>

        <!-- 详情页面-->
        <el-dialog :title="showInfoTitle" :visible.sync="divShowInfo" width="30%">
            <div>
                <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                          v-loading="storloading"
                          @selection-change="handleSelectionChange"
                          :data="storInfoList"
                          stripe
                          border
                          style="width: 100%">
                 <!--   <el-table-column
                            prop="title"
                            align="left"
                            label="標題">
                    </el-table-column>-->
                    <el-table-column
                            prop="carNumber"
                            align="left"
                            label="車號">
                    </el-table-column>
                    <el-table-column
                            prop="qty"
                            align="right"
                            label="數量">
                        <template slot-scope="scope">
                            <template v-if="scope.row.itemName=='PIT_PAPER'">
                                {{scope.row.qty+parseFloat(scope.row.oneCar)}}
                            </template>
                            <template v-else-if="scope.row.itemName=='TOGLUE'">
                                {{scope.row.qty+parseFloat(scope.row.twoCar)}}
                            </template>
                            <template v-else-if="scope.row.itemName=='CREPE_PAPER'">
                                {{scope.row.qty+parseFloat(scope.row.threeCar)}}
                            </template>
                            <template v-else>
                                {{scope.row.qty}}
                            </template>
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="feedDate"
                            align="left"
                            width="110"
                            :label="$t('m.t_date')">
                        <template slot-scope="scope">
                            <template v-if="scope.row.feedDate!=0">
                                {{scope.row.feedDate*1000 | date('%Y-%m-%d') }}
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="divShowInfo = false">關閉</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getItemStorList,getItemAll,getItemStorListAll,deleteItemById,getItemRecord,updateItemStock,getStockAdjId,getRollingItemRecordByNo,addItems} from '../api/api'
    export default {
        data() {
            var validateFile=(rule, value, callback) => {
                if (value==""){
                    document.getElementById("file_name").innerHTML=this.$t('m.t_selectthefile');
                    callback(new Error(' '));
                }
                callback();
            };
            return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                //查询條件
                serchItemName:"",
                itemStorList:[],
                itemOptions:[],
                custNo:'',
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                tableloading:false,
                dialogCodeName:'',
                dialogCodeVisible:false,
                addEidtloading:false,
                itemForm:{
                    id:'',
                    itemName:'',
                    qty:'',
                    oldQty:0,
                    remark:'',
                    adjQty:''
                },
                itemRules:{
                    itemName:[
                        {required: true, message: "請輸入產品", trigger: 'change' },
                    ],
                    qty:[
                        {required: true, message: "請輸入調整數量", trigger: 'change' },
                        {required: true,validator: function (rule, value, callback) {
                            var reg=/^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
                            if (value!=""&&value!=null){
                                if(!reg.test(value)){
                                   callback(new Error('請輸入正確的格式，且只有兩位小數'));
                                }
                            }
                            callback();
                        },trigger: 'blur' }
                    ],
                    adjQty:[
                        {required: true, message: "請輸入調整數量", trigger: 'change' },
                       {required: true,validator: function (rule, value, callback) {
                            var reg=/^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
                            if (value!=""&&value!=null){
                                if(!reg.test(value)){
                                    callback(new Error('請輸入正確的格式，且只有兩位小數'));
                                }
                            }
                            callback();
                        },trigger: 'blur' }
                    ],
                    remark:[
                        {required: true, message: "請輸入原因", trigger: 'change' },
                    ],
                },

                diaItemsName:'',
                dialogItemVisible:false,
                itemLogList:[],
                selectionItems:[],

                showInfoTitle:'',
                divShowInfo:false,
                storInfoList:[],
                storloading:false
            }
        },
        methods: {
            calculateQty(value){
                var reg=/^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
                if (value!=""&&value!=null){
                    if(!reg.test(value)){
                        return;
                    }else{
                        this.itemForm.adjQty=Number(this.itemForm.oldQty+parseFloat(value)).toFixed(2);
                    }
                }
            },
            calculateAdjQty(value){
                var reg=/^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
                if (value!=""&&value!=null){
                    if(!reg.test(value)){
                        return ;
                    }else{
                        if(this.itemForm.oldQty < parseFloat(value)){
                            this.itemForm.qty = Number(parseFloat(value)-this.itemForm.oldQty).toFixed(2);
                        }else{
                            this.itemForm.qty = Number((this.itemForm.oldQty - parseFloat(value))*-1).toFixed(2);
                        }
                    }
                }
            },
            validateItemName(itemName){
                var params={itemName:itemName};
                getItemRecord(params).then(data=>{
                    let item=data.data.data;
                    if(item!=null && item!=""){
                        this.itemForm.itemName="";
                        return  this.$message.error("該產品名已經存在！");
                    }
                });
            },
            showInfo(row){
            this.showInfoTitle="详情";
            this.divShowInfo=true;
            this.storloading=true;
            let params=null;
            if(row.remark==null){
               params = {name: ""};
            }else{
               params = {name: row.remark};
            }
            return getRollingItemRecordByNo(params).then(data => {
                this.storInfoList = data.data.data;
                this.storloading=false;
            });
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            //日志记录
            updateLog(id){
                this.tableloading=true;
                this.dialogItemVisible=true;
                this.diaItemsName="修改日誌";
                return getStockAdjId(id).then(data=>{
                    this.itemLogList=data.data.data;
                    this.tableloading=false;
                });
            },
            validateNum(num){
                if(num!='' && num!=null) {
                    var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if (!re.test(num)) {
                        this.itemForm.Qty="";
                       return  this.$message.error("請輸入正確的格式，且只有兩位小數");
                    }
                }
            },

            itemListSave(){
                this.$refs.itemForm.validate((valid) => {
                    if (valid) {
                        this.addEidtloading=true;
                        if (this.itemForm.id!='') {
                            var params = Object.assign({}, this.itemForm);
                            return updateItemStock(params).then(res => {
                                if (res.data.errcode == 200) {
                                    this.$message.success("修改货品成功!");
                                    this.dialogCodeVisible = false;
                                    this.addEidtloading = false;
                                    this.itemClean();
                                    this.getItemStorList();
                                } else {
                                    this.addEidtloading = false;
                                    this.$message.error(res.errmsg);
                                }
                            }).catch((error) => {
                                console.log("updateSave Error");
                            })
                        } else {
                            var params = Object.assign({}, this.itemForm);
                            return addItems(params).then(res => {
                                if (res.data.errcode == 200) {
                                    this.$message.success(this.$t('m.m_newgoodssuc'));
                                    this.dialogCodeVisible = false;
                                    this.addEidtloading = false;
                                    this.itemClean();
                                    this.getItemStorList();
                                } else {
                                    this.addEidtloading = false;
                                    this.$message.error(res.errmsg);
                                }
                            }).catch((error) => {
                                console.log("updateSave Error");
                            })
                        }
                    }
                });
            },
            itemListAdd(){
                this.itemClean();
                this.dialogCodeName="添加產品";
                this.dialogCodeVisible=true;
            },
            itemClean(){
                this.itemForm.id="";
                this.itemForm.qty="";
                this.itemForm.remark="";
                this.itemForm.adjQty="";
                this.itemForm.itemName="";
                this.itemForm.oldQty=0;
            },
            //编辑
            itemEdit(row){
                //this.resetForm("itemForm");
                this.dialogCodeName="修改產品倉存";
                this.dialogCodeVisible=true;
                this.getItemNameById(row.itemName);
            },
            getItemNameById(itemName){
                var params={itemName:itemName};
                getItemRecord(params).then(data=>{
                    let item=data.data.data;
                    Object.assign(this.itemForm,item);
                    this.itemForm.qty="";
                    this.itemForm.adjQty="";
                    this.itemForm.remark="";
                });
            },
            //隐藏事件
            updateStatus(id) {
                this.$confirm('你確定要隱藏該產品嗎?',this.$t('m.m_info'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.t_cancel'),
                    type: 'warning'
                }).then(()=> {
                    deleteItemById(id).then(data=>{
                        let {data:res={}}=data;
                        if(res.errcode==200){
                            this.$message.success('隱藏成功');
                            this.getItemStorList();
                        }else{
                            this.$message.error("隱藏失败！");
                        }
                    });
                });

            },
            itemOptionChange(){
             this.getItemStorList();
            },
            getItemOptions(itemCode){
                if (itemCode!="") {
                    getItemAll(itemCode).then(data => {
                        this.itemOptions = data.data.data;
                    });
                }
            },
            itemPageChange(val){
                this.getItemStorList();
            },
            handleSelectionChange(val){

            },
            getItemStorList(){
                this.tableloading=true;
                 var params={itemName:this.serchItemName};
                 return getItemStorListAll(params).then(data=>{
                 this.itemStorList=data.data.data;

                 this.tableloading=false;
                 });
                /* var params={page:this.pager.page,size:this.pager.size,itemName:this.serchItemName};
               return getItemStorList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.itemStorList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });*/
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
        },
        activated(){
            this.addEidtloading=false;
            this.getItemStorList();
        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("ITEM_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("ITEM_EDIT");
            },
            canDetails(){
                return this.$store.getters.hasPermission("ITEM_DETAILS");
            },
            candHide(){
                return this.$store.getters.hasPermission("ITEM_HIDE");
            },
            candLOG(){
                return this.$store.getters.hasPermission("ITEM_LOG");
            },
        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/ItemStor.vue